import React, { useEffect, useState } from "react";
import "./adminAccountDeletion.css";

import {
 fetchScheduledDeletionRequests,
 fetchPendingDeletionRequests,
 deleteAccountNow,
 cancelDeletionRequest,
} from "./adminAccountDeletionService";

const AdminAccountDeletionPage = () => {
 const [requests, setRequests] = useState([]);
 const [loading, setLoading] = useState(false);
 const [showPendingOnly, setShowPendingOnly] = useState(false);
 const [actionLoadingId, setActionLoadingId] = useState(null);

 useEffect(() => {
 loadRequests(showPendingOnly);
 }, [showPendingOnly]);

 const loadRequests = async (pendingOnly = false) => {
 setLoading(true);

 const response = pendingOnly
 ? await fetchPendingDeletionRequests()
 : await fetchScheduledDeletionRequests();

 if (response.status === 200) {
 setRequests(response.data || []);
 } else {
 alert(response.message || "Failed to load deletion requests");
 setRequests([]);
 }

 setLoading(false);
 };

 const handleDeleteNow = async (requestId, name) => {
 const confirmed = window.confirm(
 `Are you sure you want to permanently delete account for ${name}?`
 );
 if (!confirmed) return;

 const adminNote = window.prompt("Enter admin note (optional):", "") || "";

 setActionLoadingId(requestId);

 const response = await deleteAccountNow(requestId, adminNote);

 if (response.status === 200) {
 alert(response.message || "Account deleted successfully");
 loadRequests(showPendingOnly);
 } else {
 alert(response.message || "Failed to delete account");
 }

 setActionLoadingId(null);
 };

 const handleCancel = async (requestId, name) => {
 const confirmed = window.confirm(
 `Cancel deletion request for ${name}?`
 );
 if (!confirmed) return;

 const adminNote = window.prompt("Enter admin note (optional):", "") || "";

 setActionLoadingId(requestId);

 const response = await cancelDeletionRequest(requestId, adminNote);

 if (response.status === 200) {
 alert(response.message || "Deletion request cancelled successfully");
 loadRequests(showPendingOnly);
 } else {
 alert(response.message || "Failed to cancel deletion request");
 }

 setActionLoadingId(null);
 };

 const formatDateTime = (value) => {
 if (!value) return "-";
 return new Date(value).toLocaleString();
 };

 return (
 <div className="admin-container">
 <div className="admin-header">
 <h2>Account Deletion Management</h2>

 <div className="admin-header-actions">
 <button onClick={() => setShowPendingOnly(!showPendingOnly)}>
 {showPendingOnly ? "Show All Requests" : "Show Pending Only"}
 </button>

 <button onClick={() => loadRequests(showPendingOnly)}>
 Refresh
 </button>
 </div>
 </div>

 {loading ? (
 <p>Loading deletion requests...</p>
 ) : (
 <table className="announcement-table">
 <thead>
 <tr>
 <th>Request ID</th>
 <th>User ID</th>
 <th>Name</th>
 <th>Email</th>
 <th>Status</th>
 <th>Requested At</th>
 <th>OTP Verified At</th>
 <th>Scheduled Deletion</th>
 <th>Cancelled At</th>
 <th>Deleted At</th>
 <th>Admin Note</th>
 <th>Actions</th>
 </tr>
 </thead>

 <tbody>
 {requests.length === 0 ? (
 <tr>
 <td colSpan="12">No deletion requests found</td>
 </tr>
 ) : (
 requests.map((request) => (
 <tr key={request.requestId}>
 <td>{request.requestId}</td>
 <td>{request.userId}</td>
 <td>{request.name || "-"}</td>
 <td>{request.email || "-"}</td>
 <td>
 <span className={`status-badge status-${(request.status || "").toLowerCase()}`}>
 {request.status}
 </span>
 </td>
 <td>{formatDateTime(request.requestedAt)}</td>
 <td>{formatDateTime(request.otpVerifiedAt)}</td>
 <td>{formatDateTime(request.scheduledDeletionAt)}</td>
 <td>{formatDateTime(request.cancelledAt)}</td>
 <td>{formatDateTime(request.deletedAt)}</td>
 <td>{request.adminNote || "-"}</td>
 <td>
 <div className="action-buttons">
 <button
 onClick={() => handleDeleteNow(request.requestId, request.name)}
 disabled={actionLoadingId === request.requestId}
 >
 {actionLoadingId === request.requestId ? "Processing..." : "Delete Now"}
 </button>

 <button
 className="delete-btn"
 onClick={() => handleCancel(request.requestId, request.name)}
 disabled={
 actionLoadingId === request.requestId ||
 request.status === "DELETED" ||
 request.status === "CANCELLED"
 }
 >
 Cancel Request
 </button>
 </div>
 </td>
 </tr>
 ))
 )}
 </tbody>
 </table>
 )}
 </div>
 );
};

export default AdminAccountDeletionPage;